import { useCategoryFilters } from "./CategoryFilters.hooks";
import { Container, Button } from "./CategoryFilters.styles";
import { filtersList } from "./utils";


export const CategoryFilters = () => {
  const { activeCategory, handleChangeCategory, claimActive } = useCategoryFilters();

  if (claimActive) {
    return null;
  }

  return (
    <Container className="category-container">
      {filtersList.map((each) => (
        <Button
          id={`tab-${each.value}`}
          key={each.id}
          active={activeCategory === each.value}
          onClick={() => handleChangeCategory(each)}
        >
          {each.label}
        </Button>
      ))}
    </Container>
  )
}
